import { useGetServiceObjectQuery } from "@/services/backend/customers/customer/service-object-service";

export function ServiceObjectName(props: { serviceObjectId: string }) {
  const { serviceObjectId } = props;

  const {
    data: serviceObject,
    isLoading,
    isError,
  } = useGetServiceObjectQuery({ id: serviceObjectId });
  if (isLoading) {
    return (
      <span className="animate-pulse">
        <span className="block h-2 rounded-full bg-gray-200" />
      </span>
    );
  }

  if (isError) {
    return <span>Fehler beim Laden des Service Objekts</span>;
  }

  return <span>{serviceObject?.name}</span>;
}
